import UpdateSalesOrder from "../../../../components/@documents/sales_orders/UpdateSalesOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesOrderUpdatePage() {

    return (
        <UpdateSalesOrder 
            routeType={routeTypes.retail}
        />
    )
}